import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";
import { getSeekerBadges } from "../../../../API/api";
import { Spin, Space } from "antd";
import Tooltip from "@mui/material/Tooltip";
import styles from "./seeker.module.css";
import ServerTableAnt from "../../../AntDesignTable/ServerTableAnt";
import VizHeader from "../../../VizHeader/VizHeader";
import { SearchOutlined } from "@ant-design/icons";
import { DebounceInput } from "react-debounce-input";
import { CSVLink } from "react-csv";
import WorkspacePremiumTwoToneIcon from "@mui/icons-material/WorkspacePremiumTwoTone";
import TitleValue from "./TitleValue";
import IosShareIcon from "@mui/icons-material/IosShare";
const containerStyle = {
  width: "100%",
  // margin: "auto",
  // marginTop: "1%",
  // marginBottom: "1%",
  border: "1px solid #E0E2E6",
  background: "#FFFFFF",
  borderRadius: "12px",
  boxShadow: "0px 4px 16px 0px #1018280F",
  padding: "28px",

};
const columnsData = [
  {
    title: TitleValue("Geo"),
    dataIndex: "Geo",
    align: "left",
    width: 100,
    render: (_, raw) => (
      <>
        <span style={{
          fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500",
        }}>{raw.Geo}</span>
      </>
    ),
  },
  {
    title: TitleValue("Seeker"),
    dataIndex: "Seeker",
    align: "left",
    width: 150,

    // render: (_, row) => console.log("row", row),
    render: (_, raw) => (
      <>
        <span style={{ fontSize: "13px", fontWeight: "300" }}>
          {raw.Seeker}
        </span>
      </>
    ),
  },
  {
    title: TitleValue("Curious Mind"),
    dataIndex: "CuriousMind",
    sorter: true,
    align: "center",
    width: 150,
    render: (_, raw) => (
      <>
        {raw?.CuriousMind === "Gold" ? (
          <span>
            <Tooltip title={raw?.CuriousMind} placement="top">
              <WorkspacePremiumTwoToneIcon
                sx={{
                  color: "#FDD017",
                  cursor: "auto",
                  width: 25,
                  height: 25,
                }}
              />
            </Tooltip>
          </span>
        ) : raw?.CuriousMind === "Silver" ? (
          <span>
            <Tooltip title={raw?.CuriousMind} placement="top">
              <WorkspacePremiumTwoToneIcon
                sx={{
                  color: "#BCC6CC",
                  cursor: "auto",
                  width: 25,
                  height: 25,
                }}
              />
            </Tooltip>
          </span>
        ) : raw?.CuriousMind === "Bronze" ? (
          <span>
            <Tooltip title={raw?.CuriousMind} placement="top">
              <WorkspacePremiumTwoToneIcon
                sx={{
                  color: "#CD7F32",
                  cursor: "auto",
                  width: 25,
                  height: 25,
                }}
              />
            </Tooltip>
          </span>
        ) : (
          "-"
        )}
      </>
    ),
  },

  {
    title: TitleValue("Helping Hand"),
    dataIndex: "HelpingHand",
    sorter: true,
    align: "center",
    width: 150,
    render: (_, raw) => (
      <>
        {raw?.HelpingHand === "Gold" ? (
          <span>
            <Tooltip title={raw?.HelpingHand} placement="top">
              <WorkspacePremiumTwoToneIcon
                sx={{
                  color: "#FDD017",
                  cursor: "auto",
                  width: 25,
                  height: 25,
                }}
              />
            </Tooltip>
          </span>
        ) : raw?.HelpingHand === "Silver" ? (
          <span>
            <Tooltip title={raw?.HelpingHand} placement="top">
              <WorkspacePremiumTwoToneIcon
                sx={{
                  color: "#BCC6CC",
                  cursor: "auto",
                  width: 25,
                  height: 25,
                }}
              />
            </Tooltip>
          </span>
        ) : raw?.HelpingHand === "Bronze" ? (
          <span>
            <Tooltip title={raw?.HelpingHand} placement="top">
              <WorkspacePremiumTwoToneIcon
                sx={{
                  color: "#CD7F32",
                  cursor: "auto",
                  width: 25,
                  height: 25,
                }}
              />
            </Tooltip>
          </span>
        ) : raw?.HelpingHand === "-" ? (
          <span>-</span>
        ) : (
          ""
        )}
      </>
    ),
  },
  // #FDD017, #BCC6CC
  // #BCC6CC,
  // #CD7F32
  {
    title: TitleValue("Engagement"),
    dataIndex: "Engagement",
    align: "center",
    sorter: true,
    width: 150,
    // render: (_, raw) => console.log("first: ", raw),
    render: (_, raw) => (
      <>
        {raw?.Engagement == "Gold" ? (
          <span>
            <Tooltip title={raw?.Engagement} placement="top">
              <WorkspacePremiumTwoToneIcon
                sx={{
                  color: " #FDD017",
                  cursor: "auto",
                  width: 25,
                  height: 25,
                }}
              />
            </Tooltip>
          </span>
        ) : raw?.Engagement == "Silver" ? (
          <span>
            <Tooltip title={raw?.Engagement} placement="top">
              <WorkspacePremiumTwoToneIcon
                sx={{
                  color: "#BCC6CC",
                  cursor: "auto",
                  width: 25,
                  height: 25,
                }}
              />
            </Tooltip>
          </span>
        ) : raw?.Engagement == "Bronze" ? (
          <span>
            <Tooltip title={raw?.Engagement} placement="top">
              <WorkspacePremiumTwoToneIcon
                sx={{
                  color: "#CD7F32",
                  cursor: "auto",
                  width: 25,
                  height: 25,
                }}
              />
            </Tooltip>
          </span>
        ) : raw?.Engagement == "-" ? (
          <span>-</span>
        ) : (
          ""
        )}
      </>
    ),
  },
];
function SearchBar({ searchValue, handleSearch, setSearchValue }) {
  return (
    <>
      {" "}
      <Space.Compact>
        <span className={styles.search}>
          <SearchOutlined />
          <DebounceInput
            debounceTimeout={800}
            placeholder="Search"
            autoComplete="off"
            outline={true}
            onChange={handleSearch}
            value={searchValue}
            allowClear
            style={{ border: "none", paddingLeft: "10px" }}
          />
          {/* fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500", */}

          {searchValue.length > 3 && (
            <>
              <span className={styles.cross} onClick={() => setSearchValue("")}>
                <svg
                  fill-rule="evenodd"
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="close-circle"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                  color="#2A364A"
                  fontWeight={500}
                >
                  <path d="M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"></path>
                </svg>
              </span>
            </>
          )}
        </span>
      </Space.Compact>
    </>
  );
}

export default function SeekerAwardsStatistics({ userType }) {
  const [seekerAwards, setSeekerAwards] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [filterValue, setFilterValue] = useState("nameDesc");
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const selectUser = useSelector((state) => state.seekerType);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const cmState=useSelector((state)=>state.cmRoot)
    const overviewReducer = useSelector((state) => state.cmOverview);
  const { geoLevelId, geoLevelValue, domainId, length, check } = useSelector(
    (state) => {
      return {
        geoLevelId: state.cmRoot?.selecetdRoutingValue,
        geoLevelValue: state.cmRoot?.selectedGeoLevel?.name,
        domainId: state.cmRoot?.selectedDomainIds,
        length: state.cmRoot?.selectedDomainsObj?.length,
        check: state.cmRoot.selecetdRoutingValue,
      };
    }
  );
console.log('data',geoLevelId, geoLevelValue, domainId, length, check )
  React.useEffect(() => {
    if (check !== "") {
      setLoading(true);
      getSeekerBadges(
        geoLevelId,
        geoLevelValue,
        selectUser?.userType?.value !== null ? selectUser?.userType.value : "",
        domainId,
        filterValue,
        pageNo,
        searchValue,
        pageSize
      ).then((res) => {
        if (res === undefined) return;
        setLoading(false);
        setCount(res?.data?.count);
        setSeekerAwards(res?.data?.data);
      });
    }
  }, [
    geoLevelId,
    geoLevelValue,
    selectUser?.userType,
    domainId,
    filterValue,
    pageNo,
    searchValue,
    pageSize,
    length,
    check,
    cmState
  ]);
  // state.cmRoot.selecetdRoutingValue, overviewReducer.userTypeSelect,state.cmRoot.selectedDomainIds, state.cmRoot.selectedGeoLevel
  const rows =
    seekerAwards &&
    seekerAwards?.map((item, index) => ({
      id: index,
      Geo: item.location,
      Seeker: `${item.firstName}\u00A0${item.lastName}`,
      CuriousMind:
        item?.curiosMind?.level === 1
          ? "Gold"
          : item?.curiosMind?.level === 2
            ? "Silver"
            : item?.curiosMind?.level === 3
              ? "Bronze"
              : "-",
      HelpingHand:
        item?.helpingHand?.level === 1
          ? "Gold"
          : item?.helpingHand?.level === 2
            ? "Silver"
            : item?.helpingHand?.level === 3
              ? "Bronze"
              : "-",
      Engagement:
        item?.engagement?.level === 1
          ? "Gold"
          : item?.engagement?.level === 2
            ? "Silver"
            : item?.engagement?.level === 3
              ? "Bronze"
              : item?.engagement?.level === -1
                ? "-"
                : "-",
    }));

  const handleSearch = (event) => {
    setSearchValue(event.target.value);
  };

  return (
    <Spin spinning={loading}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          textAlign: "center",
        }}
      >
        <VizHeader isBold={true} type={4}>
          Seeker Awards Statistics
        </VizHeader>
      </div>

      <Box className={styles.header}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            // paddingBottom: "15px",
            width: "100%",
          }}
        >
          <SearchBar
            searchValue={searchValue}
            handleSearch={handleSearch}
            setSearchValue={setSearchValue}
          />
          <Box>
            {rows && (
              <div style={{ display: "flex" }}>
                <span style={{ display: "flex" }}>
                  <CSVLink
                    filename={"TableContent.csv"}
                    data={rows}
                    style={{
                      padding: "3px",
                      fontSize: "12px",
                      // display: "flex",
                      // alignItems: "baseline",
                      textDecorationLine: "none",
                      color: "grey",
                    }}
                  >
                    <Tooltip title="Data Export">
                      <IosShareIcon />
                    </Tooltip>
                  </CSVLink>
                </span>
              </div>

            )}
          </Box>
        </Box>
      </Box>
      {/* <button onClick={() => setPageNo((pageNo) => pageNo + 1)}>Move</button> */}
      <Box sx={{ mt: 2 }}>
        <ServerTableAnt
          columns={columnsData}
          data={rows}
          setPageNo={setPageNo}
          setPageSize={setPageSize}
          count={count}
          setFilterValue={setFilterValue}
          pageNo={pageNo}
        />
      </Box>
    </Spin>
  );
}
